export default __webpack_public_path__ + "static/media/gallery06.3e27a499.jpg";